"use client";

import { useEffect } from "react";
import { reportErrorToRum } from "@/lib/rum";

// Route-segment error boundary. Catches errors thrown during render in any
// route below the root layout. React 19 does NOT bubble these to
// window.onerror, so RUM only sees them because we explicitly report here.
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportErrorToRum(error);
  }, [error]);

  return (
    <div className="max-w-xl mx-auto my-16 p-8 text-center">
      <h1 className="text-2xl font-semibold mb-4">Something went wrong</h1>
      <p className="mb-6 text-gray-600">
        We&apos;ve been notified and are looking into it.
      </p>
      <button
        onClick={reset}
        className="px-6 py-2 rounded-md border border-gray-300 hover:bg-gray-50"
      >
        Try again
      </button>
    </div>
  );
}
